import React,{useRef} from 'react';
import { Component } from 'react';
import ReactDOM from 'react-dom';

import Header from "../components/header";
import Float from "../components/float";
import Footer from "../components/footer";

import Info from "../components/profile/info";

export default class Profile extends Component {
    constructor(props){
        super(props)

        this.state = {
            name: '',
            user:[],
            address: [],
            formUpdate:{
                name:'',
                lastname:'',
                identy:'',
                mail:'',
                password:'',
                password_new:'',
                phone:'',
                address:'',
                town:'',
                token:'',
                country_id:'',
                state_id:'',
                city_id:'',
            },
            cities:[],
            addressList:[],
            error: null,
            brands:[],
            brands_2:[],
            categories:[],
            info:[],
        }
        
        this.formUpdateSubmit = this.formUpdateSubmit.bind(this)
        this.handleChangeFormUpdate = this.handleChangeFormUpdate.bind(this)
        this.onChangeCity = this.onChangeCity.bind(this)
        this.clickFormUpdate = this.clickFormUpdate.bind(this)
        
    }

    //update_form started
    handleChangeFormUpdate(e){
        this.setState({
            formUpdate:{
                ...this.state.formUpdate,
                [e.target.name]:e.target.value
            }
        })
    }

    onChangeCity(e){
        this.setState({city: e.target.value});
        this.setState({
            formUpdate:{
                ...this.state.formUpdate,
                city_id:e.target.value,
            }
        });
    }

    clickFormUpdate(){
        $('#clickSubmit').click();
    }

    formUpdateSubmit = async (e) => {
        e.preventDefault()
        if(
            this.state.formUpdate.name == '' ||
            this.state.formUpdate.lastname == '' ||
            this.state.formUpdate.identy == '' ||
            this.state.formUpdate.mail == '' ||
            this.state.formUpdate.phone == '' ||
            this.state.formUpdate.address == ''||
            this.state.formUpdate.town == '' ||
            this.state.formUpdate.city_id == ''
        ){
            swal({
                text: "Debes digitar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        try{
            let configUpdate = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formUpdate)
            }
            let resUpdate = await fetch(`${https}api/update`,configUpdate)
            let dataUpdate = await resUpdate.json()
            if(dataUpdate == 1){
                swal.close();
                swal({
                    text: "Gracias por actualizar tus datos",
                    icon: imageURL,
                    button: "OK!",
                    dangerMode: false,
                    closeOnClickOutside: false,
                })
                    .then((willDelete) => {
                        if (willDelete) {
                        } else {
                            
                        }
                    });
            }else if(dataUpdate == 2) {
                swal({
                    text: "Este correo ya se encuentra registrado",
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataUpdate == 3) {
                swal({
                    text: "Para actualizar sus datos ingrese la contraseña correcta",
                    icon: "warning",
                    button: "OK!",
                });
            }else{
                alert('ocurrio un error');
                setTimeout(function (){
                    location.reload();
                },1000)
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    //update_form finished
    

    async componentDidMount(){
        //user
        try{
            let res = await fetch(https+'api/user/'+userId)
            let data = await res.json()
            this.setState({
                user:data,
                formUpdate:{
                    ...this.state.formUpdate,
                    name:data.name,
                    lastname:data.lastname,
                    identy:data.identy,
                    mail:data.mail,
                    phone:data.phone,
                },
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //address
        try{
            let res = await fetch(https+'api/address/'+userId)
            let data = await res.json()
            this.setState({
                address:data,
                formUpdate:{
                    ...this.state.formUpdate,
                    address:data.address,
                    town:data.town,
                    country_id:data.country,
                    state_id:data.state,
                    city_id:data.city,
                },
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //address
        try{
            let res = await fetch(https+'api/addressList')
            let data = await res.json()
            this.setState({
                addressList:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }


        //informacion
        try{
            let res = await fetch(https+'api/info')
            let data = await res.json()
            this.setState({
                info:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands
        try{
            let res = await fetch(https+'api/brandsHeader')
            let data = await res.json()
            this.setState({
                brands:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands 2
        try{
            let res = await fetch(https+'api/brandsHeader2')
            let data = await res.json()
            this.setState({
                brands_2:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //categories
        try{
            let res = await fetch(https+'api/categoriesHeader')
            let data = await res.json()
            this.setState({
                categories:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //city
        try{
            let res = await fetch(https+'api/cities')
            let data = await res.json()
            this.setState({
                cities:data
            })
        }catch (error) {
            this.setState({
                error
            })
        }

    }
    
    render() {
        return (
            <div>
                <Header
                    brands={this.state.brands}
                    brands_2={this.state.brands_2}
                    categories={this.state.categories}
                />
                <Info
                    user={this.state.user}
                    address={this.state.address}
                    cities={this.state.cities}
                    onChange={this.handleChangeFormUpdate}
                    onSubmit={this.formUpdateSubmit}
                    onChangeCity={this.onChangeCity}
                    form={this.state.formUpdate}
                    click={this.clickFormUpdate}
                    addressList={this.state.addressList}
                />
                <Float
                    info={this.state.info}
                />
                <Footer
                    info={this.state.info}
                />
            </div>
        );
    }

}

if (document.getElementById('content_profile')) {
    ReactDOM.render(<Profile />, document.getElementById('content_profile'))
}
